module.exports = __webpack_public_path__ + "static/media/shared-360.db1fcdf5.svg";